import axios, { AxiosError, AxiosRequestConfig } from 'axios';

import { store } from './app/store';
import { logout } from './store/actions/authActions';

const API_VERSION = process.env.REACT_APP_API_VERSION || '/v1';
const BASE_URL =
  process.env.REACT_APP_BE_BASE_URL || 'https://api.fumisconnected.com/api';

// Check out config if you need to add new cases - https://github.com/axios/axios

const instance = axios.create({
  baseURL: BASE_URL + API_VERSION,
});

// Token handling interceptor
instance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const apiKey = store.getState()?.auth?.user?.apiKey || '';
    if (apiKey) {
      config.headers.authorization = apiKey;
    }
    config.headers.Accept = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Error handling interceptor - replace with according action (right now logged in console)
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (400 === error.response.status) {
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

// Authentication failed interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (401 === error.response.status) {
      store.dispatch(logout());
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export type CustomAxiosError<T = { message?: string }> = AxiosError<T>;

export default instance;
